/** @format */

import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { signInFetch } from 'services/auth/operation'
import { overlaySelectors } from 'services/globalSelectors'
import { Input, Button, Label } from 'components'
import userIcon from 'assets/icons/user.svg'
import userFocusIcon from 'assets/icons/userFocus.svg'
import lockIcon from 'assets/icons/lock.svg'
import lockFocusIcon from 'assets/icons/lockFocus.svg'

export const Login = ({ setPage }) => {
  const dispatch = useDispatch()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const errorMessage = useSelector(overlaySelectors.errorMessage)

  const onSubmit = () => dispatch(signInFetch(email, password))

  return (
    <>
      <Input
        onSubmit={onSubmit}
        onChange={setEmail}
        value={email}
        type="text"
        placeholder="E-mail"
        icon={userIcon}
        iconHover={userFocusIcon}
      />
      <Input
        onSubmit={onSubmit}
        onChange={setPassword}
        value={password}
        type="password"
        placeholder="Password"
        icon={lockIcon}
        iconHover={lockFocusIcon}
      />
      <Label side="center" color="#ff0000" text={errorMessage} />
      <Label
        side="right"
        text="Forgot password?"
        event={() => setPage('forgot')}
      />
      <Button value="Login" event={onSubmit} />
      <Label
        side="center"
        text="Registration"
        event={() => setPage('registration')}
      />
    </>
  )
}
